import { createFileRoute, redirect } from "@tanstack/react-router";
import { LogisticsSectorDashboard } from "../../components/dashboard/logistics-sector";
import { hasSectorDashboards } from "../../lib/dashboard/sectors";

/**
 * Sector 3 · Dashboard (Logistics & Hospitality): today's arrivals, transfers,
 * beds and meals. A NOC's page; for the host it is the top of the Logistics
 * Desk (user, 2026-10-31: one page), so they are sent there.
 */
export const Route = createFileRoute("/_app/dashboard/logistics")({
	beforeLoad: ({ context }) => {
		if (!hasSectorDashboards(context.session)) throw redirect({ to: "/", replace: true });
		if (context.session.active_role !== "ORGANIZATION") throw redirect({ to: "/logistics/desk", replace: true });
	},
	staticData: { contentWidth: "full" },
	component: Page,
});

function Page() {
	const { session } = Route.useRouteContext();
	return <LogisticsSectorDashboard session={session} />;
}
